import { useTranslation } from 'react-i18next'
import { useField } from 'formik'
import { Box, Typography } from '@mui/material'

import { UserLogged } from '@/state/auth/models'
import { RoleType } from '@/enums/role.enum'
import { BrandsOptions } from '@/state/brands/models'

import InputFormikField from '@/views/components/input-formik-field/index.component'
import InputFormikAutocomplete from '@/views/components/input-formik-autocomplete/index.component'
import InputFormikSwitch from '@/views/components/input-formik-switch/index.component'

import InputFormikPassword from '@/views/components/input-formik-password/index.component'

type Props = {
  loggedUser: UserLogged
  brandsOptions: BrandsOptions[]
}

const FieldsProfileDetails = ({ loggedUser, brandsOptions }: Props) => {
  const { t } = useTranslation()

  const [field] = useField('resetPassword')

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography component="p">{t('profile.firstname')}</Typography>
        <Box width={300}>
          <InputFormikField name="firstname" />
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography component="p">{t('profile.lastname')}</Typography>
        <Box width={300}>
          <InputFormikField name="lastname" />
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography component="p">{t('labels.username')}</Typography>
        <Box width={300}>
          <InputFormikField name="username" disabled />
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography component="p">{t('profile.email')}</Typography>
        <Box width={300}>
          <InputFormikField name="email" disabled />
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography component="p">{t('profile.brands')}</Typography>
        <Box width={300}>
          <InputFormikAutocomplete
            name="brands"
            disabled={loggedUser.role !== RoleType.SUPER_ADMIN}
            options={brandsOptions || []}
            getOptionLabel={(option) => option.name}
            multiple
            limitTags={2}
            chipTags
          />
        </Box>
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <Typography component="p" className="fontWeight-700">
          {t('profile.resetPassword')}
        </Typography>
        <Box width={50}>
          <InputFormikSwitch name="resetPassword" />
        </Box>
      </Box>
      {field.value && (
        <>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography component="p">{t('profile.newPassword')}</Typography>
            <Box width={300}>
              <InputFormikPassword name="password" />
            </Box>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography component="p">
              {t('profile.confirmPassword')}
            </Typography>
            <Box width={300}>
              <InputFormikPassword name="confirmPassword" />
            </Box>
          </Box>
        </>
      )}
    </>
  )
}

export default FieldsProfileDetails
